/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const ConnectAssistantStepMessages = defineMessages({
  title: {
    id: 'Slack.ConnectAssistantStepMessages.title',
    defaultMessage: 'Connect your assistant'
  },
  subtitle: {
    id: 'Slack.ConnectAssistantStepMessages.subtitle',
    defaultMessage:
      'Make the assistant available to customers by adding it to a Slack app as a bot user.'
  },
  stepOne: {
    id: 'Slack.ConnectAssistantStepMessages.stepOne',
    defaultMessage:
      'On the {appHome} tab, click {edit} and enter a display name and default username for your virtual assistant and then click {save}. Enable the {alwaysShowMyBotAsOnline} toggle.'
  },
  appHome: {
    id: 'Slack.ConnectAssistantStepMessages.appHome',
    defaultMessage: 'App Home'
  },
  edit: {
    id: 'Slack.ConnectAssistantStepMessages.edit',
    defaultMessage: 'Edit'
  },
  save: {
    id: 'Slack.ConnectAssistantStepMessages.save',
    defaultMessage: 'Save'
  },
  alwaysShowMyBotAsOnline: {
    id: 'Slack.ConnectAssistantStepMessages.alwaysShowMyBotAsOnline',
    defaultMessage: 'Always Show My Bot as Online'
  },
  stepTwo: {
    id: 'Slack.ConnectAssistantStepMessages.stepTwo',
    defaultMessage:
      'On the {appHome} tab, find the {showTabs} section. Enable the {messagesTab} toggle and check the {allowUsers} checkbox.'
  },
  showTabs: {
    id: 'Slack.ConnectAssistantStepMessages.showTabs',
    defaultMessage: 'Show Tabs'
  },
  messagesTab: {
    id: 'Slack.ConnectAssistantStepMessages.messagesTab',
    defaultMessage: 'Messages Tab'
  },
  allowUsers: {
    id: 'Slack.ConnectAssistantStepMessages.allowUsers',
    defaultMessage:
      'Allow users to send Slash commands and messages from the messages tab'
  },
  stepThree: {
    id: 'Slack.ConnectAssistantStepMessages.stepThree',
    defaultMessage:
      '{optional}: To add support for showing buttons, menus, and disambiguation options in the Slack app, go to the {interactivityAndShortcuts} tab and enable the feature. Paste your request URL in the provided text entry field, and then click {saveChanges}.'
  },
  optional: {
    id: 'Slack.ConnectAssistantStepMessages.optional',
    defaultMessage: 'Optional'
  },
  interactivityAndShortcuts: {
    id: 'Slack.ConnectAssistantStepMessages.interactivityAndShortcuts',
    defaultMessage: 'Interactivity & Shortcuts'
  }
});
